const { Alert } = require("react-bootstrap")

const SuccessAlert = ({ content }) => content ? <Alert variant='success'>{ content }</Alert> : null
const ErrorAlert = ({ content }) => content ? <Alert variant='danger'>{ content }</Alert> : null
const WarningAlert = ({ content }) => content ? <Alert variant='warning'>{ content }</Alert> : null

export { SuccessAlert, ErrorAlert, WarningAlert }